// extracted by mini-css-extract-plugin
export default {"roundInfo":"RoundInfo_roundInfo__+QvUu"};